import { gql, useMutation } from '@apollo/client';

import type { LogoutMutation, LogoutMutationVariables } from './__generated__/useLogout.gql';

const LOGOUT = gql`
  mutation Logout {
    logout {
      success
    }
  }
`;

export const useLogout = () => {
  return useMutation<LogoutMutation, LogoutMutationVariables>(LOGOUT);
};
